import { LogIn, LogOut, Upload, Bell, type LucideIcon } from "lucide-react"

type NotificationConfig = {
  message: (data: Record<string, string>) => string
  icon: LucideIcon
}

const notificationTypes: Record<string, NotificationConfig> = {
  impersonation_started: {
    message: (data) => `${data.impersonator_name} s'est connecté à votre compte — Raison : ${data.reason}`,
    icon: LogIn,
  },
  impersonation_ended: {
    message: (data) => `${data.impersonator_name} s'est déconnecté de votre compte`,
    icon: LogOut,
  },
  import_completed: {
    message: (data) => {
      const count = parseInt(data.created_count || "0")
      const errors = parseInt(data.error_count || "0")
      const base = `Import terminé : ${count} projet${count > 1 ? "s" : ""} créé${count > 1 ? "s" : ""}`
      return errors > 0 ? `${base} (${errors} erreur${errors > 1 ? "s" : ""})` : base
    },
    icon: Upload,
  },
  import_failed: {
    message: () => "L'import a échoué",
    icon: Upload,
  },
}

export function getNotificationMessage(type: string, data: Record<string, string>): string {
  const config = notificationTypes[type]
  return config ? config.message(data) : type
}

export function getNotificationIcon(type: string): LucideIcon {
  return notificationTypes[type]?.icon ?? Bell
}
